import { render } from "./TransferSalesmanActionTokoList.vue?vue&type=template&id=5024c98a&scoped=true"
import script from "./TransferSalesmanActionTokoList.vue?vue&type=script&lang=js"
export * from "./TransferSalesmanActionTokoList.vue?vue&type=script&lang=js"

import "./TransferSalesmanActionTokoList.vue?vue&type=style&index=0&id=5024c98a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5024c98a"

export default script